/* eslint-disable */
import {
  Box,
  fade,
  Grid,
  Grow,
  makeStyles,
  Typography,
  Fade,
} from '@material-ui/core';
import { useEffect } from 'react';
import { get } from 'lodash';
import cx from 'classnames';
import { ReactComponent as PatientWatermark } from 'assets/icons/patient.svg';
import { ReactComponent as GenderWatermark } from 'assets/icons/gender_watermark.svg';
import { ReactComponent as AgeWatermark } from 'assets/icons/age_watermark.svg';
import { ReactComponent as PatientIcon } from 'assets/icons/patient.svg';
import { ReactComponent as GenderIcon } from 'assets/icons/gender_big.svg';
import { ReactComponent as AgeIcon } from 'assets/icons/age_big.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getMetrics } from '../../../redux_store';
import { ANIMATION_TIMEOUT } from '../constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(3),
    },
  },
  centerPaper: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(0),
      paddingTop: theme.spacing(0),
    },
  },
  gridItem: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    padding: 24,
    borderRadius: theme.shape.borderRadius,
    height: '100%',
    marginRight: theme.spacing(3),
    minHeight: 440,
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(0),
    },
  },
  fullWidthTable: {
    marginRight: 0,
  },
  addNewButton: {
    height: '100%',
    marginRight: theme.spacing(2),
  },
  infoBox: {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius * 1.5,
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 8px 24px rgba(0, 168, 255, 0.3)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 32px rgba(0, 168, 255, 0.4)',
    },
  },
  // patientBox: {
  //   background: `linear-gradient(135deg, ${theme.colors.lightBlue} 0%, ${theme.colors.blue5} 100%)`,
  // },
  // genderBox: {
  //   background: `linear-gradient(135deg, ${theme.colors.blue5} 0%, ${theme.colors.lightBlue2} 100%)`,
  // },
  // averageAgeBox: {
  //   background: `linear-gradient(135deg, ${theme.colors.lightBlue3} 0%, ${theme.colors.lightBlue} 100%)`,
  // },
  patientBox: {
    backgroundColor: fade(theme.colors.lightBlue, .98),
  },
  genderBox: {
    backgroundColor: fade(theme.colors.blue5, .96),
  },
  averageAgeBox: {
    backgroundColor: fade(theme.colors.blue4, .98),
  },
  watermark: {
    position: 'absolute',
    right: '-7%',
    top: '-16%',
    opacity: 0.3,
    pointerEvents: 'none',
  },
  genderWatermark: {
    top: '-10%',
    right: 0,
    height: 140,
  },
  patientWatermark: {
    top: '-20%',
    right: '-10%',
    height: 170,
    width: 170,
    opacity: .07,
  },
  infoText: {
    fontSize: 13,
    fontWeight: 400,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: theme.palette.common.white,
  },
  icon: {
    width: 58,
    marginRight: 2,
  },
  icon2: {
    width: 62,
    marginLeft: -2,
  },
  infoNumber: {
    maxHeight: 44,
    marginTop: -2,
    marginLeft: -1,
    fontSize: 36,
    fontWeight: 400,
    color: theme.palette.common.white,
  },
  divider: {
    width: '100%',
    margin: theme.spacing(4, 0),
  },
  chartTitle: {
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: theme.colors.blue2,
  },
  emptyDataWidget: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexDirection: 'column',
  },
  emptyDataTitle: {
    marginTop: theme.spacing(2),
    color: fade(theme.colors.blue2, 0.5),
  },
}));

const InfoBlocks = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { en: { charts } } = useSelector((state) => state.i18n);
  const {
    metadata: { currentAccount },
  } = useSelector((state) => state.user);
  const { metrics } = useSelector((state) => state.charts);
  const averageAge = get(metrics, 'averageAge');
  const femalePercentage = `${Math.round(
    get(metrics, 'femalePercentage', 0) * 100,
  )}%`;
  const numberOfPatients = get(metrics, 'numberOfPatients');

  useEffect(() => {
    dispatch(getMetrics(currentAccount.uuid));
  }, []);

  return <Grid container item xs={12} sm={12} md={12} lg={4}>
    <Grid
      item
      xs={12}
      sm={12}
      md={6}
      lg={12}
      className={classes.paper}
    >
      <Grow in timeout={ANIMATION_TIMEOUT}>
        <Box className={cx(classes.infoBox, classes.patientBox)}>
          <Box p={4} display='flex'>
            <div className={classes.icon2}>
              <PatientIcon
                style={{ width: '100%', height: '100%' }}
              />
            </div>
            <Box pl={4}>
              <Fade in={metrics !== null} timeout={1000}>
                <div>
                  <Typography className={classes.infoNumber}>
                    {numberOfPatients || '—'}
                  </Typography>
                  <Typography className={classes.infoText}>
                    {charts.numberOfPatients}
                  </Typography>
                </div>
              </Fade>
            </Box>
          </Box>
          <PatientWatermark className={cx(classes.watermark, classes.patientWatermark)} />
        </Box>
      </Grow>
    </Grid>
    <Grid
      item
      xs={12}
      sm={12}
      md={6}
      lg={12}
      className={cx(classes.paper, classes.centerPaper)}
    >
      <Grow in timeout={ANIMATION_TIMEOUT}>
        <Box className={cx(classes.infoBox, classes.genderBox)}>
          <Box p={4} display='flex'>
            <div className={classes.icon}>
              <GenderIcon style={{ width: '100%', height: '100%' }} />
            </div>
            <Box pl={4}>
              <Fade in={metrics !== null} timeout={1000}>
                <div>
                  <Typography className={classes.infoNumber}>
                    {metrics ? femalePercentage : '—'}
                  </Typography>
                  <Typography className={classes.infoText}>
                    {charts.genderFemale}
                  </Typography>
                </div>
              </Fade>
            </Box>
          </Box>
          <GenderWatermark
            className={cx(classes.watermark, classes.genderWatermark)}
          />
        </Box>
      </Grow>
    </Grid>
    <Grid item xs={12} sm={12} md={12} lg={12}>
      <Grow in timeout={ANIMATION_TIMEOUT}>
        <Box className={cx(classes.infoBox, classes.averageAgeBox)}>
          <Box p={4} display='flex'>
            <div className={classes.icon}>
              <AgeIcon style={{ width: '100%', height: '100%' }} />
            </div>
            <Box pl={4}>
              <Fade in={metrics !== null} timeout={1000}>
                <div>
                  <Typography className={classes.infoNumber}>
                    {averageAge || '—'}
                  </Typography>
                  <Typography className={classes.infoText}>
                    {charts.averageAge}
                  </Typography>
                </div>
              </Fade>
            </Box>
          </Box>
          <AgeWatermark className={classes.watermark} />
        </Box>
      </Grow>
    </Grid>
  </Grid>;
};

export default InfoBlocks;
